import { Link } from 'react-router-dom';

const TABS = [
  {
    label: 'Dashboard',
    to: '/',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  },
  {
    label: 'Leads',
    to: '/leads',
    icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
  },
];

// Same rule as NavMenu: the dashboard owns "/" only, Leads owns any path with "leads".
const isActive = (to, route) => (to === '/' ? route === '/' : route.includes(to.slice(1)));

// z-[40] keeps the bar under the nav (50), the header (200), the live-activity toast (300)
// and modals.
const MobileTabBar = ({ activeRoute }) => (
  <nav
    aria-label="Main tabs"
    className="fixed bottom-0 left-0 right-0 z-[40] bg-white border-t border-border flex"
    style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
  >
    {TABS.map((tab) => {
      const active = isActive(tab.to, activeRoute);
      return (
        <Link
          key={tab.to}
          to={tab.to}
          data-attr={`tab-${tab.label.toLowerCase()}`}
          aria-current={active ? 'page' : undefined}
          className={`flex-1 flex flex-col items-center justify-center h-16 text-xs font-medium ${
            active ? 'text-primary' : 'text-gray-500'
          }`}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={tab.icon} />
          </svg>
          <span>{tab.label}</span>
        </Link>
      );
    })}
  </nav>
);

export default MobileTabBar;
